/* eslint-disable no-console */

const hooks = {
  onResourceLoaded: function() {
    console.log('all resources is loaded')
  },
  onTouchPreloader: function() {
    console.log('touching preloader')
  },
  onSelectQuilt: function() {
    console.log('a quilt is selected')
  },
  onRecreate: function() {
    console.log('recreating')
  },
  logout: function() {
    console.log('logout hook is triggered')
  },
  invite: function() {
    console.log('invite hook is triggered')
  },
  join: function() {
    console.log('join hook is triggered')
  },
  share: function() {
    console.log('share hook is triggered')
  },
  draw: function() {
    console.log('draw hook is triggered')
  },
}

window._hooks = hooks

export default hooks
